export type FeatureDataProps = {
  id: number;
  title: string;
  content: string;
  image?: string;
  video?: string;
};

const features: FeatureDataProps[] = [
  {
    id: 1,
    title: 'Preserve your memories',
    content:
      'Ideal for graduations, weddings, and special moments—remove distractions, preserve the memories.',
    image:
      'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/a42d3c2a-8176-4ca5-d4ad-aa6c6db91900/public',
  },
  {
    id: 2,
    title: 'Enhance social media impact',
    content:
      'Perfect for creating professional-looking content for your social media platforms without watermarks or distractions.',
    image:
      'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/b9392b01-5803-4481-d242-f19301a93b00/public',
  },
  {
    id: 3,
    title: 'Unlock stock image potential',
    content:
      'Transform stock photos into unique assets by removing watermarks and enhancing visual appeal for your projects.',
    image:
      'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/81f9716c-a90a-4b88-33cf-b10070a83800/public',
  },
];

export default features;
